import { render, staticRenderFns } from "./OurTableHeader.vue?vue&type=template&id=7c848190&"
import script from "./OurTableHeader.vue?vue&type=script&lang=js&"
export * from "./OurTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./OurTableHeader.vue?vue&type=style&index=0&id=7c848190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports